import { Http } from '@/lib/http';
export class ReportIssueService extends Http {
  constructor() {
    super();
    this.endpoint = 'report-issues';
  }

  /**
   * Creates a new report issue
   */
  create(data) {
    return this.httpClient().post(`${this.endpoint}`, data);
  }
  /**
   * Find all report issues
   *
   * Accepts query object to paginate the results
   */
  findAll(query = {}) {
    return this.httpClient().get(`${this.endpoint}`, { params: query });
  }

  /**
   * Uploads an image for a report
   */
  uploadImage(id, imageFile) {
    const formData = new FormData();
    formData.append('file', imageFile);
    return this.httpClient().post(`${this.endpoint}/file/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
}
